import React from 'react';
import { createComponent } from '@lit-labs/react';

import Dsy from './dsyui';

const LitComp = Dsy.components.DsyGrid;

export const DsyGrid = createComponent(
  React,
  'dsy-grid',
  LitComp,
  {},
);

export default DsyGrid;
